import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Loader from "react-loader-spinner";
import {Table} from "react-bootstrap";
import { getServiceInvoice } from "../store/api/Services";
const ServiceInvoice = () => {
    const { serviceID, serviceType } = useParams();
    const dispatch = useDispatch();
    const invoice = useSelector(state => state.service.serviceInvoice);
    useEffect(() => {
        async function fetchData(){ dispatch( getServiceInvoice(serviceType, serviceID));}
        fetchData();
    },[]);
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
    }, []);
    return (
        <div className="container-fluid mt-2">
            {!invoice && <Loader type="BallTriangle" color="#bb1370" height={100} width={100} />}
            {invoice &&
                <div className="card">
                    <div className="card-header">فاکتور خدمات</div>
                    <div className="card-body">
                        <table className="tableStyle" style={{ marginBottom: "12px" }}>
                            <tbody>
                                <tr>
                                    <td className="columnForPrint"><span>شماره فاکتور: </span><span>{invoice.InvoiceNumber}</span></td>
                                    <td className="columnForPrint"><span>تاریخ فاکتور: </span><span>{invoice.InvoiceDate}</span></td>
                                </tr>
                                <tr>
                                    <td className="columnForPrint"><span>نام محصول: </span><span>{invoice.ProductName}</span></td>
                                    <td className="columnForPrint"><span>مدل محصول: </span><span>{invoice.ProductModel}</span></td>
                                </tr>
                            </tbody>
                        </table>
                        <Table className="tableStyle">
                            <thead className="tableHeader">
                                <td>کدکالا/خدمت</td>
                                <td>شــرح</td>
                                <td>مدل کالا</td>
                                <td>تعداد</td>
                                <td>قیمت واحد</td>
                                <td>قیمت کل</td>
                            </thead>
                            <tbody>
                                {invoice?.details && Array.isArray(invoice.details) &&
                                    invoice.details.map((item, i) => {
                                        return <tr className="tableRow" key={i}>
                                            <td className="columnForPrint">{item.ProductCode}</td>
                                            <td className="columnForPrint">{item.ProductName}</td>
                                            <td className="columnForPrint">{item.ProductModel}</td>
                                            <td className="columnForPrint">{item.ProductCount}</td>
                                            <td className="columnForPrint">{item.UnitPrice.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                                            <td className="columnForPrint">{item.TotalPrice.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </Table>
                        <table className="tableStyle mt-2">
                            <tbody>
                                <tr>
                                    <td className="columnForPrint"><span>تخفیف: </span><span>{invoice.Discount}</span></td>
                                </tr>
                                <tr>
                                    <td className="columnForPrint"><span>مالیات: </span><span>{invoice.Tax}</span></td>
                                </tr>
                                <tr>
                                    <td className="columnForPrint"><span>جمع کل: </span><span>{invoice.TotalCost.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="card-footer">
                        <button className="btn btn-success" style={{fontSize:"12px"}} onClick={()=>{window.print()}}>چاپ فاکتور</button>
                        </div>
                </div>
            }

        </div>
    );
}
export default ServiceInvoice;